import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import StreamButton from './StreamButton'
import { mediaType as MediaType } from '@bt-react/constants'
import { State } from '../../../dataStore/reducers/reducerType'
import { showStreamModal } from '../../../dataStore/actions/ui/uiActions'

const StreamButtonIndex: FC = () => {
  const isActive = useSelector((state: State) => state.ui.showStreamModal || state.room.mediaType === MediaType.EVENT_STREAM) as boolean
  const dispatch = useDispatch()

  const onStreamClick = () => dispatch(showStreamModal())

  return <StreamButton
    isActive={isActive}
    onStreamClick={onStreamClick}
  />
}

export default StreamButtonIndex